export const Types = {
  SIGN_UP: 'SIGN_UP',
  SIGN_UP_FAIL: 'SIGN_UP_FAIL',
  SIGN_UP_SUCCESS: 'SIGN_UP_SUCCESS',
};

export const onSignUp = (
  firstName,
  lastName,
  email,
  password,
  birthdate,
  country,
  state,
  available,
  locale,
  cognitoSub = null,
  completeSignup = false,
  inviteToken = null,
) => ({
  type: Types.SIGN_UP,
  payload: {
    firstName,
    lastName,
    email,
    password,
    birthdate,
    country,
    state,
    available,
    locale,
    cognitoSub,
    completeSignup,
    inviteToken,
  },
});

export const onSignUpSuccess = (available, codeDeliveryDetails = null) => ({
  type: Types.SIGN_UP_SUCCESS,
  available,
  payload: { codeDeliveryDetails },
});

export const onSignUpFail = (error) => ({
  type: Types.SIGN_UP_FAIL,
  payload: { error },
});
